import { render } from "./countup.vue?vue&type=template&id=5b6a7dc2"
import script from "./countup.vue?vue&type=script&lang=js"
export * from "./countup.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__